module.exports = __webpack_public_path__ + "static/laundromatslider-10-min-4d9ae2bad4ef09bfec4cdd75aa5c1527.jpg";